var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.93,166.36c9.9,0,17.93-8.03,17.93-17.93V58.79c0-9.9,8.03-17.93,17.93-17.93h98.61c9.9,0,17.93-8.03,17.93-17.93s-8.03-17.93-17.93-17.93H58.79C29.08,5,5,29.08,5,58.79v89.64c0,9.9,8.03,17.93,17.93,17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.21,5h-98.61c-9.9,0-17.93,8.03-17.93,17.93s8.03,17.93,17.93,17.93h98.61c9.9,0,17.93,8.03,17.93,17.93v89.64c0,9.9,8.03,17.93,17.93,17.93s17.93-8.03,17.93-17.93V58.79c0-29.71-24.08-53.79-53.79-53.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.07,345.64c-9.9,0-17.93,8.03-17.93,17.93v89.64c0,9.9-8.03,17.93-17.93,17.93h-98.61c-9.9,0-17.93,8.03-17.93,17.93s8.03,17.93,17.93,17.93h98.61c29.71,0,53.79-24.08,53.79-53.79v-89.64c0-9.9-8.03-17.93-17.93-17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.39,471.14H58.79c-9.9,0-17.93-8.03-17.93-17.93v-89.64c0-9.9-8.03-17.93-17.93-17.93s-17.93,8.03-17.93,17.93v89.64c0,29.71,24.08,53.79,53.79,53.79h98.61c9.9,0,17.93-8.03,17.93-17.93s-8.03-17.93-17.93-17.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M489.07,238.07H22.93c-9.9,0-17.93,8.03-17.93,17.93s8.03,17.93,17.93,17.93h466.14c9.9,0,17.93-8.03,17.93-17.93s-8.03-17.93-17.93-17.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.dedd820fef4e5aedc4c657165c238325.svg";
export { ForwardRef as ReactComponent };